import React, { useState } from 'react';
import cn from 'classnames';
import style from "../common.module.scss"
import LineIcon from '../../../shared/icons/LineIcon';
import KazahstanIcon from '../../../shared/icons/country/KazahstanIcon.png'
import RussianIcon from '../../../shared/icons/country/RussianIcon.png'
import UsbekistanIcon from '../../../shared/icons/country/UsbekistanIcon.png'
import {t} from "i18next";

const OrdersInfoDirections = ({ item, senderName = '', recipientName = '' }) => {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const optionsDate = { day: 'numeric', month: 'short' };
        const optionsWeekday = { weekday: 'short' };

        let formattedDate = date.toLocaleDateString('ru-RU', optionsDate);
        let formattedWeekday = date.toLocaleDateString('ru-RU', optionsWeekday);

        formattedDate = formattedDate.replace('.', '');
        formattedWeekday = formattedWeekday.replace('.', '');

        return `${formattedDate}, ${formattedWeekday}`;
    };

    const formatTime = (timeString) => {
        const date = new Date(timeString);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const countryIcons = {
        "63556b49614a6ddc9ceeb61e": KazahstanIcon,
        "63556bc1614a6ddc9ceeb61f": RussianIcon,
        "648b0836d64a46fc66c74273": UsbekistanIcon,
    };

    return (
        <div className={cn(style.shipping_wrapper)}>
            <LineIcon />
            <div className={style.shipping_content}>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t("balanceList.loading")}</span>
                    <div className={style.shipping_column_text}>
                        {formatDate(item?.shippingDate)}
                    </div>
                    <div className={style.shipping_column_footer}>
                        {formatTime(item?.shippingDate)} - {" "}{formatTime(item?.shippingDateEnd)}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t("common.tableHead.from")}</span>
                    <div className={style.shipping_column_main}>
                        <img
                            src={countryIcons[item?.countryIdFrom]}
                            className={style.shipping_column_countryIcon}
                        />
                        <div className={style.shipping_column_text}>
                            {item?.cityFromName}
                        </div>
                    </div>
                    <div className={style.shipping_column_footer}>
                        {item?.addressFrom}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('ordersCreate.view.label.sender')}</span>
                    <div className={style.shipping_column_text}>
                        {senderName}
                    </div>
                    <div className={style.shipping_column_footer}>
                        {recipientName}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t("balanceList.unloading")}</span>
                    <span className={style.shipping_column_text}>
                        {formatDate(item?.unloadingDate)}
                    </span>
                    <span className={style.shipping_column_footer}>
                        {formatTime(item?.shippingDate)} - {" "}{formatTime(item?.shippingDateEnd)}
                    </span>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t("common.tableHead.from")}</span>
                    <span className={style.shipping_column_main}>
                        <img
                            src={countryIcons[item?.countryIdTo]}
                            className={style.shipping_column_countryIcon}
                        />
                        <div className={style.shipping_column_text}>
                            {item?.cityToName}
                        </div>
                    </span>
                    <span className={style.shipping_column_footer}>
                        {item?.addressTo}
                    </span>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('ordersCreate.view.label.recipient')}</span>
                    <span className={style.shipping_column_text}>
                        {recipientName}
                    </span>
                    <span className={style.shipping_column_footer}>
                        {senderName}
                    </span>
                </div>

            </div>
        </div>
    );
};

export default OrdersInfoDirections;